<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "RutePenyebrangan",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
